import {
  formatDateOrDash,
  formatDateTimeOrDash,
} from '#/utils/date';

function resolveWarehouseName(warehouse) {
  if (!warehouse) {
    return '—';
  }

  return warehouse.name || warehouse.displayName || warehouse.id || '—';
}

function resolveWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '—';
  }

  const codeName = [warehouse.code, warehouse.name].filter(Boolean).join(' ');
  return codeName || warehouse.displayName || warehouse.id || '—';
}

export function mapStockReturnMeta(detail) {
  return {
    code: detail?.returnNo || '-',
    status: detail?.status || '',
    returnDate: formatDateOrDash(detail?.returnDate),
    sourceWarehouseName: resolveWarehouseName(detail?.sourceWarehouse),
    sourceWarehouseLabel: resolveWarehouseLabel(detail?.sourceWarehouse),
    targetWarehouseName: resolveWarehouseName(detail?.targetWarehouse),
    targetWarehouseLabel: resolveWarehouseLabel(detail?.targetWarehouse),
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark || '',
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    closeDate: formatDateTimeOrDash(detail?.history?.completedAt),
    lineCount: detail?.lines?.length ?? detail?.lineCount ?? 0,
  };
}
